import { render, staticRenderFns } from "./StaffContents.vue?vue&type=template&id=b0819078&scoped=true&"
import script from "./StaffContents.vue?vue&type=script&lang=js&"
export * from "./StaffContents.vue?vue&type=script&lang=js&"
import style0 from "./StaffContents.vue?vue&type=style&index=0&id=b0819078&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0819078",
  null
  
)

export default component.exports